import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Menu,
  Home,
  Settings,
  ChevronDown,
  ChevronRight,
  TrendingUpDown,
  Shapes,
  Coins,
  Users,
  Quote,
  FileText,
} from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserDropdown from "./UserProfile";
import SuryaLogoMain from "../../assets/images/SuryaLogoMain.png";
import LogoutConfirmModal from "./LogoutConfirmModal";
import { User, LogOut } from "lucide-react";
import { AuthContext } from "../../Context/ContextFunctions";
import NotificationBell from "../NotificationBell";
import NotificationDetailsModal from "../NotificationDetailsModal";
import NotificationPanel from "../NotificationPanel";
import { useNotifications } from "../../Context/NotificationContext";
import { GetNotificationCount, GetNotificationList } from "../../services/Notification/NotificationApi";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isMasterOpen, setIsMasterOpen] = useState(false);
  const [isSourceOpen, setIsSourceOpen] = useState(false);
  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const [isCityOpen, setIsCityOpen] = useState(false);
  const [isStateOpen, setIsStateOpen] = useState(false);
  const [userProfile, setShowUserProfile] = useState(false);
  const [mobileMenu, showMobileMenu] = useState(false);
  const [showConfirmationModal, setConfirmationModal] = useState(false);
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { authDetails, isAccessible } = useContext(AuthContext);

  const profileRef = useRef(null);

  const location = useLocation();
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [isCRMOpen, setIsCRMOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const { notificationCount, setNotificationCount, setNotifications, isNotificationUpdate, setIsNotificationUpdate } = useNotifications();
  const prevCountRef = useRef(notificationCount);

  const togglePanel = () => {
    GetNotificationListData();
    setOpen(!open);

  }
  useEffect(() => {

    if ((authDetails?.userKeyID !== null && authDetails?.userKeyID !== undefined && authDetails?.userKeyID !== "") || isNotificationUpdate) {
      GetNotificationCountData()
      if (isNotificationUpdate) {
        setIsNotificationUpdate(false)

      }
    }
  }, [authDetails, isNotificationUpdate])

  useEffect(() => {
    GetNotificationCountData();
    const interval = setInterval(() => {
      GetNotificationCountData();
    }, 1 * 60 * 1000); // 3 minutes

    return () => clearInterval(interval);
  }, []);

  const GetNotificationListData = async () => {

    try {
      const response = await GetNotificationList(authDetails?.userKeyID);
      if (response.data?.statusCode === 200) {
        const list = response.data?.responseData?.data || [];
        setNotifications(list)

      }

    } catch (error) {

      console.log(error);
    }
  };
  const GetNotificationCountData = async () => {

    try {
      const response = await GetNotificationCount(authDetails?.userKeyID);
      if (response.data?.statusCode === 200) {
        const count = response.data?.responseData?.notificationCount || [];
        setNotificationCount(count)
        GetNotificationListData()
        if (count > prevCountRef.current) {
          setOpen(!open);
        }
        prevCountRef.current = count;
      }

    } catch (error) {

      console.log(error);
    }
  };

  const closePanel = () => setOpen(false);

  const handleMouseEnter = (item) => {
    if (window.innerWidth >= 1024) {
      // lg breakpoint
      setHoveredItem(item);
      if (item === "Master") setIsMasterOpen(true);
      if (item === "AdminReport") setIsReportOpen(true);
      if (item === "CRMMaster") setIsCRMOpen(true);
    }
  };



  useEffect(() => {
    function handleClickOutside(event) {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowUserProfile(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleMouseLeave = (item) => {
    if (window.innerWidth >= 1024) {
      if (item === "Master") setIsMasterOpen(false);
      if (item === "AdminReport") setIsReportOpen(false);
      if (item === "CRMMaster") setIsCRMOpen(false);
      setHoveredItem(null);
    }
  };

  const toggleMaster = () => {
    if (window.innerWidth < 1024) {
      setIsMasterOpen(!isMasterOpen);
      // Close source and type when master is toggled
      setIsSourceOpen(false);
      setIsTypeOpen(false);
    }
  };

  const toggleSource = () => {
    if (window.innerWidth < 1024) {
      // Close type if source is being opened
      if (!isSourceOpen) {
        setIsCityOpen(false);
        setIsStateOpen(false);
        setIsSourceOpen(false);
        setIsTypeOpen(false);
      }
      setIsSourceOpen(!isSourceOpen);
    }
  };

  const toggleType = () => {
    if (window.innerWidth < 1024) {
      // Close source if type is being opened
      if (!isTypeOpen) {
        setIsCityOpen(false);
        setIsStateOpen(false);
        setIsSourceOpen(false);
        setIsTypeOpen(false);
      }
      setIsTypeOpen(!isTypeOpen);
    }
  };

  const toggleCity = () => {
    if (window.innerWidth < 1024) {
      if (!isCityOpen) {
        setIsCityOpen(false);
        setIsStateOpen(false);
        setIsSourceOpen(false);
        setIsTypeOpen(false);
      }
      setIsCityOpen(!isCityOpen);
    }
  };

  const toggleState = () => {
    if (window.innerWidth < 1024) {
      if (!isStateOpen) {
        setIsCityOpen(false);
        setIsStateOpen(false);
        setIsSourceOpen(false);
        setIsTypeOpen(false);
      }
      setIsStateOpen(!isStateOpen);
    }
  };
  const toggleAdminReport = () => {
    if (window.innerWidth < 1024) {
      setIsReportOpen(!isReportOpen);
      // Close source and type when master is toggled
      setIsSourceOpen(false);
      setIsTypeOpen(false);
    }
  };
  const toggleCRMMaster = () => {
    if (window.innerWidth < 1024) {
      setIsCRMOpen(!isReportOpen);
      // Close source and type when master is toggled
      setIsSourceOpen(false);
      setIsTypeOpen(false);
    }
  };

  const handleLogout = () => {
    setConfirmationModal(true); // Open confirmation modal
  };

  const onConfirmBtnClicked = () => {
    localStorage.clear(); // Clear localStorage
    navigate("/login"); // Redirect to login page
    window.location.reload(); // Refresh the page
    setConfirmationModal(false); // Close modal
  };

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) {
      return "Good Morning";
    } else if (hour >= 12 && hour < 17) {
      return "Good Afternoon";
    } else if (hour >= 17 && hour < 21) {
      return "Good Evening";
    } else {
      return "Good Night";
    }
  };
  const firstName = authDetails.employeeName?.split(" ")[0] || "";
  const greetingMessage = `${getGreeting()}, ${firstName}`;

  return (
    <>
      {/* Mobile Menu Button - Only visible on mobile */}

      {/* Navigation menu */}
      <nav class="bg-blue-600">
        <div class="mx-auto  px-2 sm:px-6 lg:px-8 rep-width">
          <div class="relative flex h-12 sm:h-16 items-center justify-between">
            <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
              {/* <!-- Mobile menu button--> */}
              <button
                type="button"
                class="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden focus:ring-inset"
                aria-controls="mobile-menu"
                aria-expanded="false"
                onClick={() => showMobileMenu(!mobileMenu)}
              >
                <span class="absolute -inset-0.5"></span>
                <span class="sr-only">Open main menu</span>
                {/* <!--
            Icon when menu is closed.

            Menu open: "hidden", Menu closed: "block"
          --> */}
                <svg
                  class="block size-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                  data-slot="icon"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                  />
                </svg>
                {/* <!--
            Icon when menu is open.

            Menu open: "block", Menu closed: "hidden"
          --> */}
                <svg
                  class="hidden size-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  aria-hidden="true"
                  data-slot="icon"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 18 18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
              {/* <div class="flex shrink-0 items-center">
                <img
                  class="h-6 w-auto rounded-full"
                  src={LogoutConfirmModal}
                  alt="Your Company"
                />
              </div> */}
              <div class="hidden sm:block">
                <div class="flex space-x-4">
                  {/* <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" --> */}
                  {/* Dashboard Link */}
                  <Link
                    to="/"
                    className={`
              flex items-center gap-1 
              px-3 py-2 
              text-gray-200 
              hover:text-white hover:bg-[#4775ff]/50 
              transition-all duration-200 
              rounded-md
              ${location.pathname === "/" ? "bg-[#1a4dff] text-white" : ""}
            `}
                    onClick={() => setIsOpen(false)}
                  >
                    <Home size={18} />
                    <p className="text-sm font-medium font-[Poppins]">
                      Dashboard
                    </p>
                  </Link>

                  {/* CRM  Master Dropdown */}
                  {(isAccessible?.Lead?.canView || isAccessible?.EnquiryReceived?.canView || isAccessible?.EstBoq?.canView || isAccessible?.Quotation?.canView || isAccessible?.SalesLog?.canView || isAccessible?.AccountLog?.canView) && (
                    <div
                      className="relative"
                      onMouseEnter={() => handleMouseEnter("CRMMaster")}
                      onMouseLeave={() => handleMouseLeave("CRMMaster")}
                    >
                      <button
                        onClick={toggleCRMMaster}
                        className={`
flex items-center gap-1 
px-3 py-2 
text-gray-200 
hover:text-white hover:bg-[#4775ff]/50 
transition-all duration-200 
rounded-md
${isReportOpen ? "bg-[#1a4dff] text-white" : ""}
`}
                      >
                        <Users size={18} />

                        <p className="text-sm font-medium font-[Poppins]">CRM </p>
                        <ChevronDown size={14} />
                      </button>

                      {isCRMOpen && (
                        <div
                          className="z-30 lg:absolute relative  lg:top-full left-0 w-full lg:w-40  mt-0 py-2 bg-white rounded shadow-lg"
                          style={{ fontSize: "14px" }}
                        >
                          {/*  Lead */}
                          {isAccessible?.Lead?.canView && (
                            <div
                              className="relative"
                              onClick={toggleType}
                              onMouseEnter={() =>
                                handleMouseEnter("fieldAttendanceReport")
                              }
                              onMouseLeave={() =>
                                handleMouseLeave("fieldAttendanceReport")
                              }
                            >
                              <Link
                                to="/lead"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Lead
                              </Link>
                            </div>
                          )}

                          {/*  Enquiry Recieved */}
                          {isAccessible?.EnquiryReceived?.canView && (
                            <div
                              className="relative"
                              onClick={toggleType}
                              onMouseEnter={() =>
                                handleMouseEnter("enquiryReceived")
                              }
                              onMouseLeave={() =>
                                handleMouseLeave("enquiryReceived")
                              }
                            >
                              <Link
                                to="/enquiry-received"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Enquiry Received
                              </Link>
                            </div>
                          )}

                          {/*  EST & BOQ */}
                          {/* {isAccessible?.EstBoq?.canView && (
                            <div
                              className="relative"
                              onClick={toggleType}
                              onMouseEnter={() => handleMouseEnter("EstBoq")}
                              onMouseLeave={() => handleMouseLeave("EstBoq")}
                            >
                              <Link
                                to="/estBoq"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                EST & BOQ
                              </Link>
                            </div>
                          )} */}

                          {/* Quotation */}
                          {isAccessible?.Quotation?.canView && (
                            <div
                              className="relative"
                              onClick={toggleType}
                              onMouseEnter={() => handleMouseEnter("Quotation")}
                              onMouseLeave={() => handleMouseLeave("Quotation")}
                            >
                              <Link
                                to="/quotation"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Quotation
                              </Link>
                            </div>
                          )}

                          {/* Add Customer */}


                          {/* Sales Log */}
                          {isAccessible?.SalesLog?.canView && (
                            <div
                              className="relative"
                              onClick={toggleState}
                              onMouseEnter={() => handleMouseEnter("SalesLog")}
                              onMouseLeave={() => handleMouseLeave("SalesLog")}
                            >
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
Designation <ChevronRight size={14} />
</div> */}
                              <Link
                                to="/salesLog"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Sales Log
                              </Link>
                            </div>
                          )}

                          {/* AccountLog Log */}
                          {isAccessible?.AccountLog?.canView && (
                            <div
                              className="relative"
                              onClick={toggleState}
                              onMouseEnter={() => handleMouseEnter("AccountLog")}
                              onMouseLeave={() => handleMouseLeave("AccountLog")}
                            >
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
Designation <ChevronRight size={14} />
</div> */}
                              <Link
                                to="/accountLog"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Account Log
                              </Link>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}


                  {/* Master Dropdown */}
                  {(isAccessible?.Employee?.canView || isAccessible?.TermsAndCondition?.canView || isAccessible?.Company?.canView || isAccessible?.Customer?.canView || isAccessible?.Product?.canView || isAccessible?.Designation?.canView || isAccessible?.Unit?.canView || isAccessible?.Site?.canView || isAccessible?.Source?.canView || isAccessible?.RoleType?.canView || isAccessible?.MIDC?.canView || isAccessible?.Taluka?.canView || isAccessible?.District?.canView || isAccessible?.State?.canView || isAccessible?.Country?.canView) && (
                    <div
                      className="relative"
                      onMouseEnter={() => handleMouseEnter("Master")}
                      onMouseLeave={() => handleMouseLeave("Master")}
                    >
                      <button
                        onClick={toggleMaster}
                        className={`
flex items-center gap-1 
px-3 py-2 
text-gray-200 
hover:text-white hover:bg-[#4775ff]/50 
transition-all duration-200 
rounded-md
z-20
${isMasterOpen ? "bg-[#1a4dff] text-white" : ""}
`}
                      >
                        <Settings size={18} />

                        <p className="text-sm z-20 font-medium font-[Poppins]">
                          Master
                        </p>
                        <ChevronDown size={14} />
                      </button>

                      {isMasterOpen && (
                        <div
                          className="z-30 lg:absolute relative lg:top-full left-0 w-full lg:w-40 mt-0 py-2 bg-white rounded shadow-lg"
                          style={{ fontSize: "14px" }}
                        >
                          {/* New emp */}
                          {isAccessible?.Employee?.canView && (
                            <div
                              className="relative"
                              onClick={toggleState}
                              onMouseEnter={() =>
                                handleMouseEnter("employeeMaster")
                              }
                              onMouseLeave={() =>
                                handleMouseLeave("employeeMaster")
                              }
                            >
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
Unit <ChevronRight size={14} />
</div> */}
                              <Link
                                to="/employee"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Employee Master
                              </Link>
                            </div>
                          )}

                          {/* Company */}
                          {(isAccessible?.TermsAndCondition?.canView || isAccessible?.Company?.canView) && (
                            <div
                              className="relative"
                              onClick={toggleState}
                              onMouseEnter={() => handleMouseEnter("Company")}
                              onMouseLeave={() => handleMouseLeave("Company")}
                            >
                              <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                                Company <ChevronRight size={14} />
                              </div>
                              {(isSourceOpen || hoveredItem === "Company") && (
                                <>
                                  <div className="lg:absolute relative lg:left-full lg:top-0 w-full lg:w-40 mt-0 lg:-mt-2 lg:ml-0 py-2 bg-white rounded shadow-lg">
                                    {isAccessible?.Company?.canView && (
                                      <Link
                                        to="/company"
                                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                        onClick={() => setIsOpen(false)}
                                      >
                                        Company
                                      </Link>
                                    )}
                                    {isAccessible?.TermsAndCondition?.canView && (
                                      <Link
                                        to="/termsAndCondition"
                                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                        onClick={() => setIsOpen(false)}
                                      >
                                        Terms And Conditions
                                      </Link>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          )}


                          {isAccessible?.Customer?.canView && (
                            <div
                              className="relative"
                              onClick={toggleState}
                              onMouseEnter={() => handleMouseEnter("Product")}
                              onMouseLeave={() => handleMouseLeave("Product")}
                            >
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
Designation <ChevronRight size={14} />
</div> */}
                              <Link
                                to="/customer"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Customers
                              </Link>
                            </div>
                          )}

                          {/* Product */}
                          {isAccessible?.Product?.canView && (
                            <div
                              className="relative"
                              onClick={toggleState}
                              onMouseEnter={() => handleMouseEnter("Product")}
                              onMouseLeave={() => handleMouseLeave("Product")}
                            >
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
         Designation <ChevronRight size={14} />
       </div> */}
                              <Link
                                to="/product"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Product
                              </Link>
                            </div>
                          )}

                          {/* Designation */}
                          {isAccessible?.Designation?.canView && (
                            <div
                              className="relative"
                              onClick={toggleState}
                              onMouseEnter={() => handleMouseEnter("Designation")}
                              onMouseLeave={() => handleMouseLeave("Designation")}
                            >
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
Designation <ChevronRight size={14} />
</div> */}
                              <Link
                                to="/designation"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Designation
                              </Link>
                            </div>
                          )}

                          {/* Unit */}
                          {isAccessible?.Unit?.canView && (
                            <div
                              className="relative"
                              onClick={toggleState}
                              onMouseEnter={() => handleMouseEnter("Unit")}
                              onMouseLeave={() => handleMouseLeave("Unit")}
                            >
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
Unit <ChevronRight size={14} />
</div> */}
                              <Link
                                to="/unit"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Unit
                              </Link>
                            </div>
                          )}

                          {/* site */}
                          {isAccessible?.Site?.canView && (
                            <div
                              className="relative"
                              onClick={toggleCity}
                              onMouseEnter={() => handleMouseEnter("Site")}
                              onMouseLeave={() => handleMouseLeave("Site")}
                            >
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
Site 
</div> */}
                              <Link
                                to="/site"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Site
                              </Link>
                            </div>
                          )}

                          {/* Source */}
                          {isAccessible?.Source?.canView && (
                            <div
                              className="relative"
                              onClick={toggleType}
                              onMouseEnter={() => handleMouseEnter("source")}
                              onMouseLeave={() => handleMouseLeave("source")}
                            >
                              <Link
                                to="/source"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                Source
                              </Link>
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
Source 
</div> */}
                            </div>
                          )}

                          {/* User Role */}
                          {isAccessible?.RoleType?.canView && (
                            <div
                              className="relative"
                              onClick={toggleType}
                              onMouseEnter={() => handleMouseEnter("User-Role")}
                              onMouseLeave={() => handleMouseLeave("User-Role")}
                            >
                              <Link
                                to="/user-role"
                                className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                onClick={() => setIsOpen(false)}
                              >
                                User Role
                              </Link>
                              {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
Source 
</div> */}
                            </div>
                          )}


                          {/* addressMaster */}
                          {(isAccessible?.MIDC?.canView || isAccessible?.Taluka?.canView || isAccessible?.District?.canView || isAccessible?.State?.canView || isAccessible?.Country?.canView) && (
                            <div
                              className="relative"
                              onClick={toggleSource}
                              onMouseEnter={() => handleMouseEnter("addressMaster")}
                              onMouseLeave={() => handleMouseLeave("addressMaster")}
                            >
                              <div className="block px-3 py-2 whitespace-nowrap text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                                Address master <ChevronRight size={14} />
                              </div>
                              {(isSourceOpen ||
                                hoveredItem === "addressMaster") && (
                                  <div className="lg:absolute relative lg:left-full lg:top-0 w-full lg:w-40 mt-0 lg:-mt-2 lg:ml-0 py-2 bg-white rounded shadow-lg">
                                    {isAccessible?.Country?.canView && (
                                      <Link
                                        to="/country"
                                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                        onClick={() => setIsOpen(false)}
                                      >
                                        Country
                                      </Link>
                                    )}
                                    {isAccessible?.State?.canView && (
                                      <Link
                                        to="/state"
                                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                        onClick={() => setIsOpen(false)}
                                      >
                                        State
                                      </Link>
                                    )}
                                    {isAccessible?.District?.canView && (
                                      <Link
                                        to="/district"
                                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                        onClick={() => setIsOpen(false)}
                                      >
                                        District
                                      </Link>
                                    )}
                                    {isAccessible?.Taluka?.canView && (
                                      <Link
                                        to="/taluka"
                                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                        onClick={() => setIsOpen(false)}
                                      >
                                        Taluka
                                      </Link>
                                    )}
                                    {isAccessible?.MIDC?.canView && (
                                      <Link
                                        to="/midc"
                                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                                        onClick={() => setIsOpen(false)}
                                      >
                                        IDC
                                      </Link>
                                    )}

                                    {/* <Link
to="/add-source"
className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
onClick={() => setIsOpen(false)}
>
State
</Link>
<Link
to="/add-source"
className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
onClick={() => setIsOpen(false)}
>
District
</Link>
<Link
to="/add-source"
className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
onClick={() => setIsOpen(false)}
>
Taluka
</Link> */}
                                  </div>
                                )}
                            </div>
                          )}

                        </div>
                      )}
                    </div>
                  )}


                  {/*Report  Master Dropdown */}
                  <div
                    className="relative"
                    onMouseEnter={() => handleMouseEnter("AdminReport")}
                    onMouseLeave={() => handleMouseLeave("AdminReport")}
                  >
                    <button
                      onClick={toggleAdminReport}
                      className={`
      flex items-center gap-1 
      px-3 py-2 
      text-gray-200 
      hover:text-white hover:bg-[#4775ff]/50 
      transition-all duration-200 
      rounded-md
      ${isReportOpen ? "bg-[#1a4dff] text-white" : ""}
    `}
                    >
                      {/* <Shapes size={18} /> */}
                      <FileText size={18} />

                      <p className="text-sm font-medium font-[Poppins]">
                        Reports{" "}
                      </p>
                      <ChevronDown size={14} />
                    </button>

                    {isReportOpen && (
                      <div
                        className="z-30 lg:absolute relative  lg:top-full left-0 w-full lg:w-40  mt-0 py-2 bg-white rounded shadow-lg"
                        style={{ fontSize: "14px", width: "max-content" }}
                      >
                        {/*  Un Process Lead */}
                        <div
                          className="relative"
                          onClick={toggleCity}
                          onMouseEnter={() => handleMouseEnter("City")}
                          onMouseLeave={() => handleMouseLeave("City")}
                        >

                          <Link
                            to="/unProcessedLead"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            UnProcessed Lead
                          </Link>

                        </div>

                        {/* Unprocessed Enquiries */}
                        <div
                          className="relative"
                          onClick={toggleCity}
                          onMouseEnter={() => handleMouseEnter("City")}
                          onMouseLeave={() => handleMouseLeave("City")}
                          style={{ width: "max-content" }}
                        >
                          {/* <div className="block whitespace-nowrap px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        UnProcess Enquires{" "}
                      </div> */}

                          <Link
                            to="/unProcessedEnquiry"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            UnProcessed Enquires
                          </Link>

                        </div>

                        {/* Unprocessed Quotation Report*/}
                        <div
                          className="relative"
                          onClick={toggleType}
                          onMouseEnter={() => handleMouseEnter("AccountReport")}
                          onMouseLeave={() => handleMouseLeave("AccountReport")}
                        >


                          <Link
                            to="/unProcessedQuotation"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            Unprocessed Quotation Report
                          </Link>
                          <Link
                            to="/unprocessed-order"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            UnProcessed Orders
                          </Link>
                          <Link
                            to="/account-report"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            Payment Pending Report
                          </Link>
                        </div>


                        {/*  Field Attendance Report */}
                        <div
                          className="relative"
                          onClick={toggleType}
                          onMouseEnter={() =>
                            handleMouseEnter("fieldAttendanceReport")
                          }
                          onMouseLeave={() =>
                            handleMouseLeave("fieldAttendanceReport")
                          }
                        >

                          <Link
                            to="/fieldAttendanceReport"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            Field Attendance Report
                          </Link>

                        </div>

                        {/* dvr */}
                        <div
                          className="relative"
                          onClick={toggleType}
                          onMouseEnter={() => handleMouseEnter("DVR")}
                          onMouseLeave={() => handleMouseLeave("DVR")}
                        >

                          <Link
                            to="/dvr"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            DVR
                          </Link>

                        </div>


                      </div>
                    )}
                  </div>

                  {isAccessible?.TaskManagement?.canView && (

                    <Link

                      to="task-management"
                      className={`
              flex items-center gap-1 
              px-3 py-2 
              text-gray-200 
              hover:text-white hover:bg-[#4775ff]/50 
              transition-all duration-200 
              rounded-md
             ${location.pathname === "/task-management" ? "bg-[#1a4dff] text-white" : ""}
            `}

                    >
                      <Home size={18} />
                      <p className="text-sm font-medium font-[Poppins]">
                        Task Management
                      </p>
                    </Link>
                  )}


                </div>
              </div>
            </div>
            <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
              {/* Notification */}
              <div className="mr-3">

                <NotificationBell togglePanel={togglePanel} />
              </div>
              {/* <!-- Profile dropdown --> */}
              <div
                ref={profileRef}
                class="relative ml-3"
              // onMouseEnter={() => setShowUserProfile(true)}
              // onMouseLeave={() => setShowUserProfile(false)}
              >
                <div
                  style={{
                    marginRight: "5px",
                  }}
                >
                  <button
                    type="button"
                    class="relative flex rounded-full bg-gray-800 text-sm focus:outline-none"
                    id="user-menu-button"
                    aria-expanded="false"
                    aria-haspopup="true"
                    onClick={() => setShowUserProfile(!userProfile)}
                  >
                    <span class="absolute -inset-1.5"></span>
                    <span class="sr-only">Open user menu</span>
                    <img
                      className="h-12 w-12 rounded-full object-cover"
                      src={SuryaLogoMain}
                      alt=""
                    />
                  </button>
                </div>

                {/* <!--
            Dropdown menu, show/hide based on menu state.

            Entering: "transition ease-out duration-100"
              From: "transform opacity-0 scale-95"
              To: "transform opacity-100 scale-100"
            Leaving: "transition ease-in duration-75"
              From: "transform opacity-100 scale-100"
              To: "transform opacity-0 scale-95"
          --> */}
                {userProfile && (
                  <div
                    class="absolute right-0  z-30 mt-2 w-48 origin-top-right rounded-md bg-white py-1 ring-1 shadow-lg ring-black/5 focus:outline-hidden"
                    role="menu"
                    style={{ width: "max-content" }}
                    aria-orientation="vertical"
                    aria-labelledby="user-menu-button"
                    tabindex="-1"
                  >
                    {/* <!-- Active: "bg-gray-100 outline-hidden", Not Active: "" --> */}
                    {/* <UserDropdown /> */}
                    <div>
                      <span className="text-sm font-bold px-5">
                        {`${greetingMessage}`}
                      </span>
                    </div>
                    <Link
                      to="/profile"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-blue-400"
                      onClick={() => setShowUserProfile(false)}
                    >
                      <User size={16} className="mr-2" />
                      Profile
                    </Link>
                    <button
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-blue-400 w-full text-left"
                      onClick={() => {
                        handleLogout();
                        setShowUserProfile(false);
                      }}
                    >
                      <LogOut size={16} className="mr-2" />
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Mobile menu, show/hide based on menu state. --> */}
        <div class="sm:hidden" id="mobile-menu">
          {mobileMenu && (
            <div class="space-y-1 px-2 pt-2 pb-3">
              {/* <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" --> */}
              {/* Dashboard Link */}
              <Link
                to="/"
                className={`
              flex items-center gap-1 
              px-3 py-2 
              text-gray-200 
              hover:text-white hover:bg-[#4775ff]/50 
              transition-all duration-200 
              rounded-md
              ${location.pathname === "/" ? "bg-[#1a4dff] text-white" : ""}
            `}
                onClick={() => {
                  setIsOpen(false);
                  showMobileMenu(false);
                }}
              >
                <Home size={18} />
                <p className="text-sm font-medium font-[Poppins]">Dashboard</p>
              </Link>
              {/* Lead */}
              <Link
                to="/lead"
                className={`
              flex items-center gap-1 
              px-3 py-2 
              text-gray-200 
              hover:text-white hover:bg-[#4775ff]/50 
              transition-all duration-200 
              rounded-md
              ${location.pathname === "/lead" ? "bg-[#1a4dff] text-white" : ""}
            `}
                onClick={() => {
                  setIsOpen(false);
                  showMobileMenu(false);
                }}
              >
                <Shapes size={18} />
                <p className="text-sm font-medium font-[Poppins]">Lead</p>
              </Link>
              {/* Enquiry Received */}
              <Link
                to="/enquiry-received"
                className={`
                       flex items-center gap-1 
                               px-3 py-2 
                           text-gray-200 
                            hover:text-white hover:bg-[#4775ff]/50
                           transition-all duration-200 
                           rounded-md
                                ${location.pathname === "/enquiry-received"
                    ? "bg-[#1a4dff] text-white"
                    : ""
                  }
       
                        `}
                onClick={() => {
                  setIsOpen(false);
                  showMobileMenu(false);
                }}
              >
                <Shapes size={18} />
                <p className="text-sm font-medium font-[Poppins]">
                  Enquiry Received
                </p>
              </Link>
              {/* EST & BOQ */}
              <Link
                to="/estBoq"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/estBoq" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => {
                  setIsOpen(false);
                  showMobileMenu(false);
                }}
              >
                <TrendingUpDown size={18} />
                <p className="text-sm font-medium font-[Poppins]">EST & BOQ</p>
              </Link>

              {/* Quotation */}
              <Link
                to="/quotation"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/quotation" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => {
                  setIsOpen(false);
                  showMobileMenu(false);
                }}
              >
                <Quote size={18} />
                <p className="text-sm font-medium font-[Poppins]">Quotation</p>
              </Link>
              {/* Product */}
              <Link
                to="/product"
                className={`
        flex items-center gap-1 
        px-3 py-2 
        text-gray-200 
         hover:text-white hover:bg-[#4775ff]/50
        transition-all duration-200 
        rounded-md
        ${location.pathname === "/product" ? "bg-[#1a4dff] text-white" : ""}
    `}
                onClick={() => {
                  setIsOpen(false);
                  showMobileMenu(false);
                }}
              >
                <Users size={18} />
                <p className="text-sm font-medium font-[Poppins]">Product</p>
              </Link>

              {/* Master Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter("Master")}
                onMouseLeave={() => handleMouseLeave("Master")}
              >
                <button
                  onClick={toggleMaster}
                  className={`
      flex items-center gap-1 
      px-3 py-2 
      text-gray-200 
      hover:text-white hover:bg-[#4775ff]/50 
      transition-all duration-200 
      rounded-md
      ${isMasterOpen ? "bg-[#1a4dff] text-white" : ""}
    `}
                >
                  <Settings size={18} />

                  <p className="text-sm font-medium font-[Poppins]">Master</p>
                  <ChevronDown size={14} />
                </button>

                {isMasterOpen && (
                  <div
                    className="lg:absolute relative lg:top-full left-0 w-full lg:w-40 mt-0 py-2 bg-white rounded shadow-lg"
                    style={{ fontSize: "14px" }}
                  >
                    {/* employeeMaster */}
                    <div
                      className="relative"
                      onClick={toggleSource}
                      onMouseEnter={() => handleMouseEnter("employeeMaster")}
                      onMouseLeave={() => handleMouseLeave("employeeMaster")}
                    >
                      <div className="block px-3 py-2 whitespace-nowrap  text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        Employee Master <ChevronRight size={14} />
                      </div>
                      {(isSourceOpen || hoveredItem === "employeeMaster") && (
                        <div className="lg:absolute relative lg:left-full lg:top-0 w-full lg:w-40 mt-0 lg:-mt-2 lg:ml-0 py-2 bg-white rounded shadow-lg">
                          <Link
                            to="/employee"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => {
                              setIsOpen(false);
                              showMobileMenu(false);
                            }}
                          >
                            Employees
                          </Link>
                        </div>
                      )}
                    </div>

                    {/* Company */}
                    <div
                      className="relative"
                      onClick={toggleState}
                      onMouseEnter={() => handleMouseEnter("Company")}
                      onMouseLeave={() => handleMouseLeave("Company")}
                    >
                      <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        Company <ChevronRight size={14} />
                      </div>
                      {(isSourceOpen || hoveredItem === "Company") && (
                        <>
                          <div className="lg:absolute relative lg:left-full lg:top-0 w-full lg:w-40 mt-0 lg:-mt-2 lg:ml-0 py-2 bg-white rounded shadow-lg">
                            <Link
                              to="/company"
                              className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                              onClick={() => {
                                setIsOpen(false);
                                showMobileMenu(false);
                              }}
                            >
                              Company
                            </Link>
                            <Link
                              to="/termsAndCondition"
                              className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                              onClick={() => {
                                setIsOpen(false);
                                showMobileMenu(false);
                              }}
                            >
                              Terms & Condition
                            </Link>
                          </div>
                        </>
                      )}
                    </div>
                    {/* Designation */}
                    <div
                      className="relative"
                      onClick={toggleState}
                      onMouseEnter={() => handleMouseEnter("Designation")}
                      onMouseLeave={() => handleMouseLeave("Designation")}
                    >
                      {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        Designation <ChevronRight size={14} />
                      </div> */}
                      <Link
                        to="/designation"
                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                        onClick={() => {
                          setIsOpen(false);
                          showMobileMenu(false);
                        }}
                      >
                        Designation
                      </Link>
                    </div>

                    {/* Unit */}
                    <div
                      className="relative"
                      onClick={toggleState}
                      onMouseEnter={() => handleMouseEnter("Unit")}
                      onMouseLeave={() => handleMouseLeave("Unit")}
                    >
                      {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        Unit <ChevronRight size={14} />
                      </div> */}
                      <Link
                        to="/unit"
                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                        onClick={() => {
                          setIsOpen(false);
                          showMobileMenu(false);
                        }}
                      >
                        Unit
                      </Link>
                    </div>

                    {/* site */}
                    <div
                      className="relative"
                      onClick={toggleCity}
                      onMouseEnter={() => handleMouseEnter("Site")}
                      onMouseLeave={() => handleMouseLeave("Site")}
                    >
                      {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        Site 
                      </div> */}
                      <Link
                        to="/site"
                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                        onClick={() => {
                          setIsOpen(false);
                          showMobileMenu(false);
                        }}
                      >
                        Site
                      </Link>
                    </div>

                    {/* Source */}
                    <div
                      className="relative"
                      onClick={toggleType}
                      onMouseEnter={() => handleMouseEnter("source")}
                      onMouseLeave={() => handleMouseLeave("source")}
                    >
                      <Link
                        to="/source"
                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                        onClick={() => {
                          setIsOpen(false);
                          showMobileMenu(false);
                        }}
                      >
                        Source
                      </Link>
                      {/* <div className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        Source 
                      </div> */}
                    </div>

                    {/* addressMaster */}
                    <div
                      className="relative"
                      onClick={toggleSource}
                      onMouseEnter={() => handleMouseEnter("addressMaster")}
                      onMouseLeave={() => handleMouseLeave("addressMaster")}
                    >
                      <div className="block px-3 py-2 whitespace-nowrap text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        Address master <ChevronRight size={14} />
                      </div>
                      {(isSourceOpen || hoveredItem === "addressMaster") && (
                        <div className="lg:absolute relative lg:left-full lg:top-0 w-full lg:w-40 mt-0 lg:-mt-2 lg:ml-0 py-2 bg-white rounded shadow-lg">
                          <Link
                            to="/state"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => {
                              setIsOpen(false);
                              showMobileMenu(false);
                            }}
                          >
                            State
                          </Link>
                          <Link
                            to="/district"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            District
                          </Link>
                          <Link
                            to="/taluka"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            Taluka
                          </Link>
                          <Link
                            to="/midc"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            IDC
                          </Link>
                          {/* <Link
                            to="/add-source"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            State
                          </Link>
                          <Link
                            to="/add-source"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            District
                          </Link>
                          <Link
                            to="/add-source"
                            className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                            onClick={() => setIsOpen(false)}
                          >
                            Taluka
                          </Link> */}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/*Report  Master Dropdown */}
              <div
                className="relative"
                onMouseEnter={() => handleMouseEnter("AdminReport")}
                onMouseLeave={() => handleMouseLeave("AdminReport")}
              >
                <button
                  onClick={toggleAdminReport}
                  className={`
      flex items-center gap-1 
      px-3 py-2 
      text-gray-200 
      hover:text-white hover:bg-[#4775ff]/50 
      transition-all duration-200 
      rounded-md
      ${isReportOpen ? "bg-[#1a4dff] text-white" : ""}
    `}
                >
                  <Settings size={18} />

                  <p className="text-sm font-medium font-[Poppins]">Report </p>
                  <ChevronDown size={14} />
                </button>

                {isReportOpen && (
                  <div
                    className="lg:absolute relative  lg:top-full left-0 w-full lg:w-40  mt-0 py-2 bg-white rounded shadow-lg"
                    style={{ fontSize: "14px" }}
                  >
                    {/*  Field Attendance Report */}
                    <div
                      className="relative"
                      onClick={toggleType}
                      onMouseEnter={() =>
                        handleMouseEnter("fieldAttendanceReport")
                      }
                      onMouseLeave={() =>
                        handleMouseLeave("fieldAttendanceReport")
                      }
                    >
                      <Link
                        to="/fieldAttendanceReport"
                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                        onClick={() => setIsOpen(false)}
                      >
                        Field Attendance Report
                      </Link>
                    </div>

                    {/*  Un Process Lead */}
                    <div
                      className="relative"
                      onClick={toggleCity}
                      onMouseEnter={() => handleMouseEnter("City")}
                      onMouseLeave={() => handleMouseLeave("City")}
                    >
                      <Link
                        to="/unProcessedLead"
                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                        onClick={() => setIsOpen(false)}
                      >
                        UnProcess Lead
                      </Link>
                    </div>

                    <div
                      className="relative"
                      onClick={toggleCity}
                      onMouseEnter={() => handleMouseEnter("City")}
                      onMouseLeave={() => handleMouseLeave("City")}
                    >
                      {/* <div className="block whitespace-nowrap px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        UnProcess Enquires{" "}
                      </div> */}
                      <Link
                        to="/unProcessedEnquiry"
                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                        onClick={() => setIsOpen(false)}
                      >
                        UnProcessed Enquires
                      </Link>
                    </div>
                    <div
                      className="relative"
                      onClick={toggleCity}
                      onMouseEnter={() => handleMouseEnter("AccountReport")}
                      onMouseLeave={() => handleMouseLeave("AccountReport")}
                    >
                      {/* <div className="block whitespace-nowrap px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500 flex justify-between items-center cursor-pointer">
                        UnProcess Enquires{" "}
                      </div> */}
                      <Link
                        to="/account-report"
                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                        onClick={() => setIsOpen(false)}
                      >
                        Payment Pending Report
                      </Link>
                      <Link
                        to="/unProcessedQuotation"
                        className="block px-3 py-2 text-gray-700 hover:bg-gray-100 hover:text-blue-500"
                        onClick={() => setIsOpen(false)}
                      >
                        Unprocessed Quotation Report
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </nav>
      {showConfirmationModal && (
        <LogoutConfirmModal
          show={showConfirmationModal}
          onHide={() => setConfirmationModal(false)}
          onConfirm={onConfirmBtnClicked}
        />
      )}
      {open && (
        <div

          className="fixed inset-0 bg-black/30 backdrop-blur-s z-40"
        />
      )}

      <NotificationPanel isOpen={open} onClose={closePanel} />

      {/* Details Modal */}
      <NotificationDetailsModal />
    </>
  );
};
export default Navbar;
